
import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SubmitButtonProps {
  isLoading?: boolean;
  text: string;
  loadingText?: string;
  className?: string;
  disabled?: boolean;
  variant?: string;
}

const SubmitButton = ({ 
  isLoading = false, 
  text, 
  loadingText = "Processing...",
  className,
  disabled = false,
  variant = "default"
}: SubmitButtonProps) => {
  return (
    <Button 
      type="submit" 
      disabled={isLoading || disabled}
      className={cn("w-full h-11 font-medium transition-all", className)}
      variant={variant as any}
      size="default"
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-b-transparent"></div>
          <span>{loadingText}</span>
        </div>
      ) : text}
    </Button>
  );
};

export default SubmitButton;
